import { useSelector } from '@lumapps/redux/react';

import { previousRouteSelector } from '../ducks/selectors';

/**
 * Retrieves the previously applied route.
 * @returns Route
 */
export const usePreviousRoute = () => {
    const previousRoute = useSelector(previousRouteSelector);

    return previousRoute;
};
